//
// Copyright (c) 2024 Emplifi, Inc.
//

// @ts-ignore
import SnippetSearchModule from "modules/shared/snippetSearch/snippetSearchModule";
import MarionetteView from "../../marionetteView";
import { type Editor, type Locale, uid } from "ckeditor5";
// @ts-ignore
import Messenger from "messaging/messenger";

import "../css/snippetSelect.css";

export default class SnippetSelect extends MarionetteView {
  private readonly editor: Editor;
  private readonly namespace: string;
  declare public snippetId: string | null | undefined;
  declare public snippetName: string | null | undefined;

  constructor(editor: Editor, locale?: Locale) {
    super(locale);
    this.editor = editor;
    this.set("snippetId", null);
    this.set("snippetName", null);
    this.namespace = "snippets-" + uid();
  }

  createModule() {
    return new SnippetSearchModule({
      region: this.region,
      namespace: this.namespace,
    });
  }

  focus() {
    if (this.module) {
      // @ts-ignore
      this.module.focus();
    }
  }

  showModule() {
    const editorConfig = this.editor.config;
    // @ts-ignore
    this.module.show({
      languageId: editorConfig.get("languageId"),
      snippetIdToBlock: editorConfig.get("snippet.blockedId"),
      touchpointId: editorConfig.get("touchPointId"),
    });
  }

  setUpVents() {
    Messenger.vent.on(
      Messenger.getFullName("list:item:selected", this.namespace),
      this._onSnippetSelect,
      this,
    );
    Messenger.vent.on(
      Messenger.getFullName("snippet:search:selected", this.namespace),
      this._onSnippetSelect,
      this,
    );
  }

  tearDownVents() {
    Messenger.vent.off(
      Messenger.getFullName("list:item:selected", this.namespace),
      this._onSnippetSelect,
      this,
    );
    Messenger.vent.off(
      Messenger.getFullName("snippet:search:selected", this.namespace),
      this._onSnippetSelect,
      this,
    );
  }

  _onSnippetSelect(model: unknown) {
    // @ts-ignore
    this.set("snippetId", model.id);
    // @ts-ignore
    this.set("snippetName", model.get("name"));
    // @ts-ignore
    this.module.setSelected(model);
  }
}
